export default __webpack_public_path__ + "static/media/i9.6befdd49.png";